module.exports = __webpack_public_path__ + "static/img/3_8_1.89fa78d1.jpg";